import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, createBlock as _createBlock, createElementVNode as _createElementVNode, renderSlot as _renderSlot, withCtx as _withCtx, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-78c6db73"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  key: 0
};
const _hoisted_2 = {
  class: "filter-items-wrapper"
};
const _hoisted_3 = {
  key: 0
};
const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1));
const _hoisted_5 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1));
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_filter_item = _resolveComponent("filter-item");
  const _component_overview_row_container = _resolveComponent("overview-row-container");
  const _component_tab_selector = _resolveComponent("tab-selector");
  const _component_graph_controller = _resolveComponent("graph-controller");
  const _component_date_picker_popup = _resolveComponent("date-picker-popup");
  const _component_button_controller = _resolveComponent("button-controller");
  const _component_b_container = _resolveComponent("b-container");
  return _openBlock(), _createBlock(_component_b_container, {
    fluid: "",
    class: "controllers"
  }, {
    default: _withCtx(() => [$props.showFilterSection ? (_openBlock(), _createBlock(_component_overview_row_container, {
      key: 0
    }, {
      left: _withCtx(() => [_createElementVNode("div", _hoisted_2, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.filters, (filter, index) => {
        return _openBlock(), _createBlock(_component_filter_item, {
          filter: filter,
          key: index,
          loading: $props.searchLoading,
          filterTitle: filter.title,
          onSelect: filter.handleSelect,
          onDeselect: filter.handleDeselect,
          selected: filter.selected,
          onSearch: $event => filter.handleSearch($event),
          onClear: filter.handleClear,
          onTriggerRefresh: $event => $options.handleTriggerRefresh({
            trigger: filter.refreshTrigger
          })
        }, null, 8, ["filter", "loading", "filterTitle", "onSelect", "onDeselect", "selected", "onSearch", "onClear", "onTriggerRefresh"]);
      }), 128))])]),
      right: _withCtx(() => [_renderSlot(_ctx.$slots, "filterSectionRightItem", {}, undefined, true)]),
      default: _withCtx(() => [$props.showFilterSectionLine ? (_openBlock(), _createElementBlock("hr", _hoisted_1)) : _createCommentVNode("", true)]),
      _: 3
    })) : _createCommentVNode("", true), $props.showTabSection ? (_openBlock(), _createElementBlock(_Fragment, {
      key: 1
    }, [$props.showTabSectionLine ? (_openBlock(), _createElementBlock("hr", _hoisted_3)) : _createCommentVNode("", true), _createVNode(_component_overview_row_container, null, {
      left: _withCtx(() => [_createVNode(_component_tab_selector, {
        pages: $props.pages,
        onChangeTab: _cache[0] || (_cache[0] = value => _ctx.$emit('changeTab', value)),
        selectedTab: $props.currentTab
      }, null, 8, ["pages", "selectedTab"])]),
      _: 1
    })], 64)) : _createCommentVNode("", true), $props.showViewSection ? (_openBlock(), _createElementBlock(_Fragment, {
      key: 2
    }, [_hoisted_4, _createVNode(_component_overview_row_container, {
      customStyle: $options.viewPeriodStyle
    }, {
      left: _withCtx(() => [_createVNode(_component_graph_controller, {
        controllers: $props.graphControllers,
        onChangeView: _cache[1] || (_cache[1] = value => _ctx.$emit('changeView', value)),
        selectedView: $props.currentView
      }, null, 8, ["controllers", "selectedView"])]),
      right: _withCtx(() => [$props.showDatePicker ? (_openBlock(), _createBlock(_component_date_picker_popup, {
        key: 0,
        datePickerDate: $props.datePickerDate,
        onSubmit: $options.handleDatePickerSubmit
      }, null, 8, ["datePickerDate", "onSubmit"])) : _createCommentVNode("", true), _withDirectives(_createVNode(_component_button_controller, {
        selectedItem: $props.currentPeriod.key,
        items: $props.tabPeriods,
        onSelectItem: _cache[2] || (_cache[2] = value => _ctx.$emit('changePeriod', value))
      }, null, 8, ["selectedItem", "items"]), [[_vShow, !$props.showDatePicker]])]),
      _: 1
    }, 8, ["customStyle"])], 64)) : _createCommentVNode("", true), _hoisted_5]),
    _: 3
  });
}